import PopoverDisclosure from "../../../../common/core-ui/PopoverDisclosure.tsx";
import BaseLinkOrButton from "../../../../common/core-ui/BaseLinkOrButton.tsx";
import useSidebarLinks from "../sidebar/useSidebarLinks.tsx";
import { useMatches } from "react-router-dom";
import CaretsSmallDown from "../../../../common/icons/CaretsSmallDown.tsx";
import { clsx } from "clsx";
import { getBasePathWithoutTrailingSlash } from "../../../../common/env.ts";
import styles from "./PageSelector.module.scss";
import { popoverOffsetY } from "./utils.ts";
import { useRef } from "react";

export default function PageSelector() {
  const { permaLinks, shelfLinks } = useSidebarLinks();
  /**
   * Snapshot the starting page location. Should the user somehow navigate away,
   * don't show the new location but keep a link back to where they were.
   * May need to be revisited if we ever intentionally support in-frame navigation.
   */
  const matchesRef = useRef(useMatches());

  const allLinks = [...permaLinks, ...shelfLinks];

  const currentLink = allLinks.find((link) =>
    matchesRef.current.find((match) => match.pathname === link.path)
  );

  const libraryLink = allLinks.find((link) => link.path === "/my-library");

  if (!currentLink) {
    return null;
  }

  if (currentLink === libraryLink) {
    return (
      <div
        className={clsx(
          "vst-button-rectangle",
          "vst-button-variant-naked",
          styles.mainButton
        )}
      >
        {currentLink?.icon}
        {currentLink?.label}
      </div>
    );
  }

  return (
    <PopoverDisclosure
      yOffset={popoverOffsetY}
      xOffset={2}
      renderTrigger={(props) => (
        <button
          {...props}
          className={clsx(
            "vst-button-rectangle",
            "vst-button-variant-naked",
            styles.mainButton
          )}
        >
          {currentLink?.icon}
          {currentLink?.label}
          <CaretsSmallDown />
        </button>
      )}
      placement="bottom-start"
    >
      <div className="vst-popover">
        <ul className="vst-popover-section vst-popover-link-list">
          <li>
            <BaseLinkOrButton to={currentLink.path}>
              {currentLink?.icon}
              {currentLink?.label}
            </BaseLinkOrButton>
          </li>
        </ul>
        <ul className="vst-popover-section vst-popover-link-list">
          <li>
            <BaseLinkOrButton
              href={getBasePathWithoutTrailingSlash() + libraryLink?.path}
            >
              {libraryLink?.label}
            </BaseLinkOrButton>
          </li>
        </ul>
      </div>
    </PopoverDisclosure>
  );
}
